//@ts-ignore
import LogoFFVoile from '../assets/images/logo_ffvoile.png';

const Header = () => {
    return <div className={"flex px-4 py-2 justify-center"}>
        <img alt="Fédération Française de Voile" className="w-40" src={LogoFFVoile}></img>
    </div>
}

export default Header;